import React, { useEffect, useState } from 'react';
import { AdminPanel, Message, SubmitButton, Validation, ValidationSummary } from 'cantarus-react-ui';
import * as Strings from '../utils/config'
import * as templateDisplayApi from '../api/templateDisplayApi';
import * as templateApi from '../api/templateApi';
import { TemplateNav } from './TemplateNav';
import { FieldDataNav } from '../components/FieldData/FieldData';
import { AdminNav } from '../components/AdminSettings/AdminSettings';
import ConfirmationPopUp from '../components/PopUp/ConfirmationPopUp';
import LogoIcon from '../../assets/images/logo.png';


const TemplateSettings = ({ moduleId, tabId, templateData, isAdmin }) => {

    //Set initial template data to save as original template data
    const [templateGroupId, setTemplateGroupId] = useState(0);
    const [templateId, setTemplateId] = useState(0);

    // The DataJson array of the templateData
    const [templateDataModels, setTemplateDataModels] = useState([{}]);

    const [unsavedTemplateData, setUnsavedTemplateData] = useState(false);
    const [showPopUp, setShowPopUp] = useState(false);
    const [showValidation, setShowValidation] = useState(false);
    const [templateSaved, setTemplateSaved] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);

    const handleExitSettings = (event) => {
        event.preventDefault();
        return true
    }

    useEffect(() => {

        //If templateData is not empty fetch and set initial Template Group Id
        const fetchTemplateGroupIdByTemplateId = async (templateId) => {
            const template = await templateApi.getTemplateById(templateId);
            setTemplateGroupId(template.GroupId);
        }

        //If templateData exists set initial values for Template Id and Data Model

        if (templateData && templateData.TemplateId
            && typeof (templateData.DataJson) !== 'undefined') {

            var dataJsonObject = JSON.parse(templateData.DataJson);

            fetchTemplateGroupIdByTemplateId(templateData.TemplateId);

            setTemplateId(templateData.TemplateId);
            setTemplateDataModels(dataJsonObject.models);
        }

    }, [templateData]);

    //Set timeout to clear template saved message
    useEffect(() => {
        setTimeout(() => setTemplateSaved(false), 5000);
    }, [templateSaved])

    useEffect(() => {
        window.onbeforeunload = null
        if (unsavedTemplateData) {
            window.onbeforeunload = handleExitSettings;
        }
    }, [unsavedTemplateData])

    const handleTemplateGroup = (groupId) => {
        setTemplateGroupId(groupId);
    }

    const handleTemplate = (id) => {

        // Set unsaved template models iff data has changed
        (templateId !== id) && setUnsavedTemplateData(true);

        setTemplateId(id);

        //Clear Data Model on Template Id change
        setTemplateDataModels([{}]);
    }

    const handleTemplateData = (newTemplateDataModel) => {
        // Set unsaved template models iff data has changed
        (JSON.stringify(templateDataModels) !== JSON.stringify(newTemplateDataModel))
            && setUnsavedTemplateData(true);

        setTemplateDataModels(newTemplateDataModel);
    }

    const handleSave = (formValidation) => {
        setShowValidation(true);
        setShowPopUp(formValidation);
    }

    const handleSaveResponse = (isSave) => {
        if (isSave) {
            var newTemplateData =
            {
                ModuleId: moduleId,
                TabId: tabId,
                TemplateId: templateId,
                DataJson: JSON.stringify({ models: templateDataModels })
            };

            templateDisplayApi.saveTemplateData(newTemplateData)
                .then(() => {
                    setSaveSuccess(true);
                    setTemplateSaved(true);
                    setUnsavedTemplateData(false);

                })
                .catch(() => {
                    setSaveSuccess(false);
                    setTemplateSaved(true);
                });
        }

        setShowPopUp(false);

        // scroll to top of admin panel
        const scrollableElement = document.getElementsByClassName('can-ui-admin-panel')[0].lastChild;
        scrollableElement.scrollTo(0, 0)
    }

    return (
        <AdminPanel
            title={Strings.AdminPanelStrings.title}
            defaultView={templateData && templateData.TemplateId ? 'fieldData' : 'template'}
            onModuleExit={() => history.go(-1)}
            phoneNumber={Strings.AdminPanelStrings.phoneNumber}
            icon={LogoIcon}
        >
            <Message
                text={saveSuccess ? Strings.MessageStrings.onSaveSuccess : Strings.MessageStrings.onSaveError}
                classes={saveSuccess ? ['success'] : ['error']}
                show={templateSaved}
                dismissButton={() => setTemplateSaved(false)}
            />

            <ConfirmationPopUp show={showPopUp} handleUserResponse={handleSaveResponse} strings={Strings.SaveTemplatePopUpStrings} />
            <Validation>
                <ValidationSummary show={showValidation} description={Strings.ValidationStrings.description} />
                <TemplateNav
                    templateGroupId={templateGroupId}
                    templateId={templateId}
                    handleTemplateGroup={handleTemplateGroup}
                    handleTemplate={handleTemplate}
                />
                <FieldDataNav
                    templateId={templateId}
                    templateDataModels={templateDataModels}
                    handleFieldDataChange={handleTemplateData}
                />
                {isAdmin && <AdminNav templateId={templateId} />}
                <SubmitButton
                    classes={'template-settings-save-button'}
                    onClick={formValidation => handleSave(formValidation)}
                    text={Strings.SaveTemplateButton.text}
                    disabled={templateId === 0}
                />
            </Validation>
        </AdminPanel>
    );

};

export default TemplateSettings;
